import React, { useContext, useEffect, useState } from 'react';
import '@stripe/stripe-js';
import { Avatar, Box, Button, ButtonBase, Divider, Typography  } from "@mui/material";
import FormBox from './building_blocks/FormBox';
import { currency } from './building_blocks/Currency';
import { apiBaseUrl } from '../utils/Api/Api';
import ProductPhotoPlaceholder from '../images/placeholder_product_image.png';
import { useNavigate } from 'react-router-dom';
import cardsPathTo from '../utils/Api/cardsPathTo';
import ordersPathTo from '../utils/Api/ordersPathTo';
import visa from '../images/visa_card.png';
import master from '../images/master_card.png';
import SnackbarContext from '../contexts/SnackbarContext';
import { ShoppingCartProductsContext } from '../contexts/ShoppingCartProductsContext';
import { Elements } from '@stripe/react-stripe-js';
import NewCardDialog from './NewCardDialog';
import PaymentMethodsDialog from './PaymentMethodsDialog';
import stripeService from './stripeService';

const ShoppingCartCheckout = () => {
  const stripePromise = stripeService.getStripe();
  const provider = JSON.parse(localStorage.getItem('shoppingProvider'));
  const checkoutProducts = JSON.parse(localStorage.getItem('shoppingCartProducts'));
  const totalAmount = localStorage.getItem('totalAmount');
  const deliveryFee = 1000  // 10 reais a entrega
  const totalDue = parseFloat(totalAmount) + deliveryFee
  const navigate = useNavigate()
  const totalQuantity = localStorage.getItem('totalQuantity');
  const currentUser = JSON.parse(localStorage.getItem('current_user'));
  const { openSnackbar } = useContext(SnackbarContext);
  const { setTotalQuantity } = useContext(ShoppingCartProductsContext);
  const { setTotalAmount } = useContext(ShoppingCartProductsContext);
  const { setShoppingCartProducts } = useContext(ShoppingCartProductsContext);
  const [openNewCardDialog, setOpenNewCardDialog] = useState(false);
  const [openPaymentMethodsDialog, setOpenPaymentMethodsDialog] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  
  let selectedPaymentIndex = 0
  localStorage.getItem('payment_method') != null ? selectedPaymentIndex = localStorage.getItem('payment_method') : selectedPaymentIndex = 0

  useEffect(() => {
    cardsPathTo.list().then(result => {
      setPaymentMethods(result.data);
      setSelectedPaymentMethod(result.data[0]); // selecting first payment method for now
    });
    document.title = 'Carrinho de compras - TudoPets.app';
  }, [])

  const handleCheckout = () => {
    ordersPathTo.save({
      provider_id: provider.id,
      total_amount: totalAmount,
      total_quantity: totalQuantity,
      payment_method_id: selectedPaymentMethod.id,
      products: checkoutProducts,
      delivery_address: currentUser.default_address.logradouro + ", " + currentUser.default_address.numero
    }).then((result) => {
      clearShoppingCart()
      openSnackbar("Pagamento iniciado com sucesso", "success");
      navigate('/orders/' + result.data.id)
    })
  }

  const clearShoppingCart = () => {
    localStorage.setItem("shoppingCartProducts", '[]');
    localStorage.setItem("totalAmount", '0');
    localStorage.setItem("totalQuantity", '0');
    setTotalAmount(0);
    setTotalQuantity(0);
    setShoppingCartProducts([]);
  }
  
  const clearShoppingCartAndGoToHome = () => {
    clearShoppingCart();
    openSnackbar("Carrinho esvaziado!", "success");
    navigate('/');
  }

  const handleCloseNewCardDialog = (paymentMethod) => {
    setOpenNewCardDialog(false);
    if (paymentMethod) {
      setPaymentMethods([...paymentMethods, paymentMethod]);
      setSelectedPaymentMethod(paymentMethod);
    }
  };

  const handleClosePaymentMethodsDialog = (paymentMethod = null) => {
    setOpenPaymentMethodsDialog(false);

    setSelectedPaymentMethod(paymentMethod);
  };

  return (
    <Box>
      <Elements stripe={stripePromise}>
        <FormBox display="flex" flexDirection="column">
          <Box>
            <Typography color="primary" variant="h5">
              <b>Carrinho de compras</b>
            </Typography>
            <Box m={2}>
              <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '8px'}}>
                <Box>
                  <Avatar sx={{border: '1px solid lightgray'}} src={provider.business_logo && 'http://localhost:3000' + provider.business_logo} />
                </Box>
                <Box flexGrow={1} ml={2} textAlign="left">
                  <Typography variant="body1"><b>{provider.name}</b></Typography>
                  <Typography fontSize={14} color="primary">
                    <ButtonBase onClick={() => navigate(`/provider/${provider.id}`) }>
                      <small>Adicionar outros itens</small>
                    </ButtonBase>
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Divider><Typography color="primary"><b>Produtos adicionados</b></Typography></Divider>
              {checkoutProducts.map((product, index) => (
                <Box key={product.id}>
                  <Box m={2} display="flex" sx={{width: "100%", height: '110px'}}>
                    <img alt="product" style={{ width: '80px', height: '120px', marginRight: '25px', objectFit: 'cover' }} src={product.item_photo ? `${apiBaseUrl}${product.item_photo}` : ProductPhotoPlaceholder} />
                    <Box sx={{width: "60%"}}>
                      <Typography mr={2} textAlign="left" variant="body2"><b>{product.title}</b></Typography>
                      <Typography mb={1} mr={2} textAlign="justify" sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '2',
                        WebkitBoxOrient: 'vertical',
                        fontSize: '13px',
                      }} color="gray">
                        {product.description}
                      </Typography>
                      <Typography variant="body2" textAlign="left"><b>{currency(product.price * product.cartQuantity)}</b> <small>({product.cartQuantity}x)</small></Typography>
                    </Box>
                  </Box>
                  {checkoutProducts.length !== index + 1 && (
                    <Divider sx={{marginTop: '30px'}} variant="middle"/>
                  )}
                </Box>
              ))}
            </Box>
            <Box mt={6}>
              <Divider><Typography color="primary"><b>Resumo de valores</b></Typography></Divider>
              <Typography mt={1} textAlign="left" variant="body2"><b>Quantidade de itens: </b>{totalQuantity}</Typography>
              <Typography mt={1} textAlign="left" variant="body2"><b>Taxa de entrega: </b>{currency(deliveryFee)}</Typography>
              <Typography mt={1} textAlign="left" variant="body2"><b>Valor dos itens: </b>{currency(totalAmount)}</Typography>
              <Typography mt={2} mb={2} textAlign="left" variant="body2"><b>Valor total com entrega: </b>{currency(totalDue)}</Typography>
            </Box>
            <Box mt={1}>
              <Divider><Typography color="primary"><b>Endereço de entrega</b></Typography></Divider>
              { currentUser && currentUser.default_address &&
                <Box>
                  <Typography mt={1} textAlign="left" variant="body2">{currentUser.default_address.cep}</Typography>
                  <Typography mt={1} textAlign="left" variant="body2">{currentUser.default_address.logradouro}, {currentUser.default_address.numero}</Typography>
                  <Typography mt={1} textAlign="left" variant="body2">{currentUser.default_address.complemento}</Typography>
                  <Typography mt={1} mb={2} textAlign="left" variant="body2">{currentUser.default_address.bairro}</Typography>
                </Box>
              }
              { currentUser && !currentUser.default_address &&
                <Box mt={2} mb={2}>
                  <Button variant="outlined" color="primary" 
                  onClick={() => navigate(`/address?from=checkout`) }>
                    Adicionar endereço de entrega
                  </Button>
                </Box>
              }
            </Box>
            <Box mt={1}>
              <Divider><Typography color="primary"><b>Forma de pagamento</b></Typography></Divider>
              { paymentMethods && paymentMethods.length === 0 &&
                <ButtonBase onClick={() => setOpenNewCardDialog(true)}>
                  <Typography mt={2} mb={2} textAlign="left" color="primary" variant="body2">Adicionar cartão de crédito</Typography>
                </ButtonBase>
              }
              { selectedPaymentMethod && (
                <Box mt={2} mb={8} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                  <Box>
                    {selectedPaymentMethod.card.brand === 'visa' ? <img alt="visa" src={visa} style={{width: '40px'}}/> : <img alt="master" src={master} style={{width: '40px'}}/>}
                  </Box>
                  <Box flexGrow={1} ml={2} textAlign="left">
                    <Typography sx={{fontSize: '14px', textTransform: 'capitalize'}}>{selectedPaymentMethod.card.brand} &#9679; {selectedPaymentMethod.card.funding === 'debit' ? 'Débito' : 'Crédito'}</Typography>
                    <Typography sx={{fontSize: '14px'}} color="gray">**** {selectedPaymentMethod.card.last4}</Typography>
                  </Box>
                  <Box flexGrow={1} ml={2} textAlign="right">
                    <ButtonBase onClick={() => setOpenPaymentMethodsDialog(true)}>
                      <Typography fontSize={14} color="orange">Trocar</Typography>
                    </ButtonBase>
                  </Box>
                </Box>
              )}
            </Box>
            <Box>
              <Button onClick={() => clearShoppingCartAndGoToHome()} variant="outlined" type="button">Limpar carrinho</Button>

              <Button sx={{marginLeft: 'auto'}} disabled={!currentUser.default_address || !selectedPaymentMethod} variant="contained" type="button" onClick={() => handleCheckout()}>Finalizar pedido</Button>
            </Box>
          </Box>
        </FormBox>

        <NewCardDialog
          open={openNewCardDialog}
          onClose={handleCloseNewCardDialog}
        />
        <PaymentMethodsDialog open={openPaymentMethodsDialog} paymentMethods={paymentMethods} setPaymentMethods={setPaymentMethods} selectedPaymentIndex={selectedPaymentIndex} onClose={handleClosePaymentMethodsDialog} setOpenNewCardDialog={setOpenNewCardDialog} />
      </Elements>
    </Box>
  );
}

export default ShoppingCartCheckout
